import cn from 'classnames'
import * as React from 'react'

import styles from './providers.module.scss'

interface IProviderProps {
  logo?: React.ReactNode
  img?: string
  alt?: string
  className?: string
}

export default function Provider({ className, logo, img, alt }: IProviderProps) {
  return img ? (
    <img alt={alt} className={cn([styles.logo, className])} src={img} />
  ) : logo ? (
    <span className={cn([styles.logo, className])}>{logo}</span>
  ) : null
}
